import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { BenefitActivationDialogExtensionInterface } from '../../../extension/interface/benefit-activation-dialog.extension.interface';
import { BenefitColumnsExtensionInterface } from '../../../extension/interface/benefit-columns.extension.interface';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { BenefitNavigationExtensionInterface } from '../../../extension/interface/benefit-navigation.extension.interface';
import { BikeBenefitActivationDialogExtension } from './extension/bike-benefit-activation-dialog.extension';
import { BikeBenefitColumnsExtension } from './extension/bike-benefit-columns.extension';
import { BikeBenefitMetadataExtension } from './extension/bike-benefit-metadata.extension';
import { BikeBenefitNavigationExtension } from './extension/bike-benefit-navigation.extension';

EXTENSIONS.registerExtension(
  new ExtensionBuilder('bike')
    .add(BenefitMetadataExtensionInterface, new BikeBenefitMetadataExtension())
    .add(BenefitNavigationExtensionInterface, new BikeBenefitNavigationExtension())
    .add(BenefitColumnsExtensionInterface, new BikeBenefitColumnsExtension())
    .add(BenefitActivationDialogExtensionInterface, new BikeBenefitActivationDialogExtension())
    .build(),
);
